import { render, staticRenderFns } from "./DiagramPreview.vue?vue&type=template&id=1785416c&scoped=true"
import script from "./DiagramPreview.vue?vue&type=script&lang=js"
export * from "./DiagramPreview.vue?vue&type=script&lang=js"
import style0 from "./DiagramPreview.vue?vue&type=style&index=0&id=1785416c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785416c",
  null
  
)

export default component.exports